if (!customElements.get("page-inject")) {
	customElements.define(
		"page-inject",
		class extends HTMLElement {
			constructor() {
				super()

				var read_more = this.querySelector(".page-inject__btn button")

				if (read_more) {
					read_more.addEventListener("click", (e) => {
						if (this.dataset.open == "true") {
							this.dataset.open = "false"
						} else {
							this.dataset.open = "true"
						}
					})
				}
			}
		}
	)
}
